var map = {
	"./img_form1_en.png": "957d",
	"./img_form1_ja.png": "b456",
	"./img_form1_ko.png": "5083",
	"./img_form1_zh.png": "d2c3",
	"./img_form1_zh_cn.png": "865c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad2c";